import React from 'react';

function Tooltip({ content, position, clickHandler }) {
  let pos;

  switch (position) {
    case 'left':
      pos = 'left';
      break;
    case 'right':
      pos = 'right';
      break;
    default:
      pos = 'center';
  }

  return (
    <span className={`tooltip tooltip--icon tooltip--${pos}`}>
      {/* The <span> element has a child <span> element that allows keyboard interaction */}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <span
        className="tooltip__trigger icon icon--inline"
        role="button"
        tabIndex="0"
        onClick={clickHandler}
        onKeyDown={clickHandler}
      >
        <svg>
          <use
            xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#info"
          />
        </svg>
        <span
          className="tooltip__content tooltip__content--primary tooltip__content--l"
        >
          <span className="tooltip__text">{content}</span>
          <span
            className="tooltip__pointer tooltip__pointer--primary"
          />
        </span>
      </span>
    </span>
  );
}

export default Tooltip;
